export default __webpack_public_path__ + "static/char-v-21-0148f049e53ce38cfebb96a117ad0d7d.png";